import React, { Component } from "react";
import Cookie from "../Components/Cookie";
import { get, post } from "../Services/http";

class CookieContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            cookies: []
        };
    }

    componentDidMount() {
        get("/api/cookie")
            .then(response => response.json())
            .then(data => {
                if (data != "accepted") {
                this.setState({
                    loading: false,
                    cookies: data.cookies,
                });
                }
                else{
                    this.setState({
                        loading: true,
                        cookies: data.cookies,
                    })
                }
            });
    }
    accept() {
        post("/api/cookie/accept")
            .then(response => response.json())
            .then(data => {
                this.setState({
                    loading: true,
                    cookies: data.cookies
                });
                window.location.reload();
            });
    }
    render() {
        if(this.state.loading)
            return null;

        return ( 
            <Cookie
                accept={() => this.accept()}
                languages={"test"}
            />
        );
    }
}
export default CookieContainer;